/*
 * Module for handling resuming or restarting a suspended wizard.
*/

rs.module("controls/navigation/wizard-suspended",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(wizardID, jsSelectors, backendUrls) {

            var continueButton = $.js(jsSelectors.continueButton);
            var restartButton = $.js(jsSelectors.restartButton);
            var abandonButton = $.js(jsSelectors.abandonButton, { required: false });

            var wizardSelector = `[data-wizard='${jsSelectors.wizard}']`;
            var wizardDiv = $(wizardSelector);

            continueButton.on("click", function () {
                var clickedButton = $(this);
                clickedButton.js(jsSelectors.spin).css("visibility", "visible");
                disableButtons(true);

                $.post(
                    {
                        url: backendUrls.resume,
                        //headers: navigationToken,
                        data: { wizardID: wizardID },
                        clearEventBanner: true
                    }
                ).done(function (_, __, jqXHR) {
                    handleResponse(jqXHR, clickedButton)
                }).fail(function (jqXHR) {
                    handleResponse(jqXHR, clickedButton)
                });
            });

            restartButton.on("click", function () {
                var clickedButton = $(this);
                clickedButton.js(jsSelectors.spin).css("visibility", "visible");
                disableButtons(true);

                $.post(
                    {
                        url: backendUrls.restart,
                        //headers: navigationToken,
                        data: { wizardID: wizardID },
                        clearEventBanner: true
                    }
                ).done(function (_, __, jqXHR) {
                    handleResponse(jqXHR, clickedButton)
                }).fail(function (jqXHR) {
                    handleResponse(jqXHR, clickedButton)
                });
            });

            abandonButton.on("click", function () {
                var clickedButton = $(this);
                clickedButton.js(jsSelectors.spin).css("visibility", "visible");
                disableButtons(true);

                $.post(
                    {
                        url: backendUrls.abandon,
                        //headers: navigationToken,
                        data: { wizardID: wizardID },
                        clearEventBanner: true
                    }
                ).done(function (_, __, jqXHR) {
                    handleResponse(jqXHR, clickedButton)
                }).fail(function (jqXHR) {
                    handleResponse(jqXHR, clickedButton)
                });
            })

            function handleResponse(jqXHR, clickedButton) {

                clickedButton.js(jsSelectors.spin).css("visibility", "hidden");
                disableButtons(false);

                // Success - response is the updated html snippet
                if (jqXHR.status == 200) {

                    var content = $(jqXHR.responseText);

                    // There should be the wizard div, and some scripts.
                    var updatedWizardDiv = content.filter(wizardSelector);
                    var scripts = content.filter("script");

                    // We leave the orignal wizardDiv - just update what is inside of it.  We also have to insert the scripts so they execute
                    if (updatedWizardDiv.exists()) {
                        wizardDiv.html(updatedWizardDiv.children().add(scripts));
                    }
                    // If the div doesn't exist, likely its some exception text to display
                    else {
                        wizardDiv.html(jqXHR.responseText);
                    }

                    // Always scroll the window back to the top. This makes sense after navigating, 
                    // as well as in the case of an error so that the error panel is in view.  
                    window.scrollTo(0, 0);
                }

                // 202 Accepted - what the wizard codes for wanting to redirect
                else if (jqXHR.status == 202) {
                    var redirectLocation = jqXHR.getResponseHeader("location");
                    if (redirectLocation) {
                        window.location = jqXHR.getResponseHeader("location");
                    }
                    else {
                        window.location = window.location.href;    
                    }                  
                }

                // Error
                else {
                    console.log("Unknown failure during wizard step navigation:")
                    console.log(jqXHR);
                }
            }

            // Disable the navigation buttons
            function disableButtons(disabled) {
                abandonButton.setDisabled(disabled);
                restartButton.setDisabled(disabled);
                continueButton.setDisabled(disabled);
            }

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);